import useSWR from 'swr';

import app from '../base';

const useReportsForDealer = (dealerId, conditions) => {
  const dayQuery = conditions?.reportDay ? `reportDay=${conditions.reportDay}` : '';
  const notesQuery = conditions?.notes?.length
    ? conditions?.notes.map((note) => `&notes=${note}`).join('')
    : '';

  const { data, error, mutate } = useSWR(
    dealerId
      ? [
          `/reports/dealerships/${dealerId}?limit=99999&${dayQuery}&${notesQuery}`,
          /* options */ undefined,
          app.auth().currentUser.uid
        ]
      : null
  );

  return {
    reports: data,
    isLoadingUser: !error && !data,
    isError: error,
    mutateReports: mutate
  };
};

export default useReportsForDealer;
